// Packages
import axios from "axios";

// Utils
import { getFromLocalStorage, setInToLocalStorage } from "../utils/webStorage";

// Servives
import TokenService from "./token.service";

// Base Url
import { BASE_URL } from "../config/siteUrls";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

class AuthService {
  login(email, password, fcmToken, deviceId, captcha) {
    return axios
      .post(BASE_URL + "api/auth/login", {
        email,
        password,
        fcmToken,
        deviceId,
        captcha,
      })
      .then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
          setInToLocalStorage("token", response.data.accessToken);
          setInToLocalStorage("refresh_token", response.data.refreshToken);
          setInToLocalStorage("user", JSON.stringify(response.data));
          this.userName =
            response.data.userProfile.firstName +
            " " +
            response.data.userProfile.lastName;
          this.role = response.data.roles[0].displayName;
        }

        if (response.data.school != null) {
          this.schoolName = response.data.school.schoolName;
          setInToLocalStorage("schoolName", this.schoolName);
          this.schoolId = response.data.school.id;
          setInToLocalStorage("schoolId", this.schoolId);
          if (response.data.school.uploadedLogo != null) {
            this.schoolLogo = response.data.school.uploadedLogo.filePath;
            setInToLocalStorage("schoolLogo", this.schoolLogo);
          }
        }

        if (this.role == "ATHLETE") {
          this.schoolName = response.data.athleteSchool.schoolName;
          setInToLocalStorage("schoolName", this.schoolName);
          this.schoolId = response.data.athleteSchool.id;
          setInToLocalStorage("schoolId", this.schoolId);
          if (response.data.athleteSchool.uploadedLogo != null) {
            this.schoolLogo = response.data.athleteSchool.uploadedLogo.filePath;
            setInToLocalStorage("schoolLogo", this.schoolLogo);
          }
        }
        setInToLocalStorage("loginUser", this.userName);
        setInToLocalStorage("loginRole", this.role);

        return response.data;
      });
  }

  getCurrentUser() {
    return JSON.parse(getFromLocalStorage("user"));
  }
}

export default new AuthService();
